module.exports = __webpack_public_path__ + "static/img/report3d_contactbg.b51b0d69.png";